//USING THIS TO HAVE REM LIKE MANAGMENT OF HEADER-SIZES WHICH OFTEN HAVE A DIFFERENT FONT
const remCalc = function(size) {
  if (isNaN(size)) {
    size = parseInt(size);
  }
  return size / typography.size.replace('px', '') + 'rem';
};

//COLORS VARIABLES
const colors = {
  white: '#FFF',
  black: '#111',
  red: '#E82A2A',
  green: '#69a24c',
  yellow: '#FFCB37',
  font: '#1B223D',
  primary: '#111',
  primaryLight: '#333',
  primaryDark: '#000',
  secondary: '#067590',
  discount: '#b44e3c',
  border: '#DDD',
  borderLight: '#F1F1F1',
  borderDark: '#333',
  borderInput: '#AAA',
  lightgrey: '#f6f6f6',
  vanillaWhite: '#fbf8f4',
  grey: '#565558',
  error: '#ff3131',
  success: '#69a24c',
  greys: [
    '#F9F9F9',
    '#F1F1F1',
    '#D5D5D5',
    '#C4C4C4',
    '#9A9A9A',
    '#777777',
    '#3B3B3B'
  ]
};
colors.font = '#111';
colors.link = colors.secondary;
colors.buy = colors.primary;
colors.backgroundLight = '#FFF';
colors.backgroundDark = colors.primary;
colors.inStock = '#339600';
colors.outOfStock = colors.red;

//FONTS
const font = {
  primary: 'roboto',
  secondary: 'roboto-condensed',
  id: 'pwp6wto'
};

const weights = {
  ultra: 100,
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
};

//TYPOGRAPHY
let typography = {
  fontFamily: font.primary,
  fontWeight: weights.normal,
  size: '14px',
  letterSpacing: '0px',
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.7em',
    marginBottom: '1rem'
  },
  header: {
    fontFamily: font.secondary,
    textTransform: 'uppercase',
    fontWeight: weights.normal,
    letterSpacing: '0px',
    secondFont: {
      fontFamily: font.primary,
      fontWeight: weights.normal
    },
    secondColor: {
      color: colors.secondary
    }
  }
};

//HEADER FONTSIZES h1-h5 (sm & md & lg & xl)
typography.header.fontSize = [
  '__',
  [remCalc(26), remCalc(31), remCalc(41), remCalc(52)],
  [remCalc(20), remCalc(24), remCalc(28), remCalc(31)],
  [remCalc(18), remCalc(20), remCalc(21), remCalc(21)],
  [remCalc(15), remCalc(16), remCalc(17), remCalc(17)],
  [remCalc(14), remCalc(14), remCalc(14), remCalc(14)]
];

const config = {
  storeName: process.env.REACT_APP_SHOP_NAME || 'Camelbak',
  routes: {
    favourites: {
      path: process.env.REACT_APP_FAV_PATH || '/bookmarks'
    },
    blog: {
      path: process.env.REACT_APP_BLOG_PATH || '/stories',
      id: process.env.REACT_APP_BLOG_ID || 156,
      mainLevel: 1,
      menu: true
    },
    brand: {
      id: process.env.REACT_APP_BRAND_ID || 0
    },
    myPages: {
      showNewsletter: true,
      showMemberCode: false,
      showAccessCode: false
    }
  },
  settings: {
    buyButtons: true,
    channelSelector: false,
    siteContentId: process.env.REACT_APP_SITECONTENT_ID || 68
  },
  lipScore: {
    Norway: '6dffc338a5c9ecd03a15590e',
    Sweden: '9d184064b1275b3b0506f56c',
    Denmark: 'dc13c5404dd4f1d346a5071e',
    Finland: 'b738b66a62787d27b567f4ef'
  },
  coreTrek: {
    Norway: {
      assistantId: 'cb6d69a1-1224-4bb3-bbaf-a0ca44c57ae3',
      apiKey: '226|mAxB46OCU4Tu88HuwT0kzicEvz8SlaneNiUTcCP318bdc378'
    }
  }
};

const general = {
  maxWidth: '1600px',
  maxWidthText: '1000px',
  pagePadding: {
    lg: '1rem',
    md: '1rem',
    sm: '1rem'
  },
  hallmarkBorder: '2px solid ' + colors.borderDark,
  radius: '3px'
};

//BUTTON
const button = {
  background: colors.primary,
  backgroundSecondary: colors.secondary,
  color: colors.white,
  colorSecondary: colors.white,
  fontFamily: font.secondary,
  fontWeight: weights.normal,
  fontSize: typography.header.fontSize[4],
  ListFontSize: typography.header.fontSize[5],
  textTransform: 'uppercase',
  letterSpacing: '0.5px'
};

//AREAS

//TOPBAR
const topBar = {
  height: {
    lg: 40,
    md: 40,
    sm: 40,
    scroll: 0
  },
  color: colors.font,
  background: '#EEE',
  fontSize: '0.9rem',
  fontWeight: weights.normal,
  usp: {
    fontSize: '0.8rem',
    fontWeight: weights.normal
  }
};

//DESKTOP HEADER
const desktopHeader = {
  height: {
    lg: 70,
    md: 70,
    scroll: 70
  },
  search: {
    height: {
      lg: 30,
      md: 30
    }
  },
  logo: {
    width: {
      lg: '200px',
      xl: '200px',
      scroll: '200px'
    }
  },
  background: colors.white,
  color: colors.font,
  nav: {
    fontSize: ['1rem', '1.1rem'],
    fontWeight: weights.normal,
    padding: '1.2rem',
    barHoverColor: colors.secondary,
    subMenu: {
      lv2: {
        fontSize: '1.1rem'
      },
      lv3: {
        fontSize: '0.9rem'
      }
    },
    height: {
      lg: 70,
      md: 70,
      scroll: 70
    },
    useSubMenuImage: true
  }
};

//MOBILE HEADER
const mobileHeader = {
  height: {
    xs: 60,
    sm: 60,
    scroll: 60
  },
  search: {
    height: {
      xs: 60,
      sm: 60
    }
  },
  logo: {
    width: '120px'
  },
  background: colors.white,
  color: colors.font,
  nav: {
    lv1: {
      fontSize: remCalc(17),
      fontWeight: typography.header.fontWeight,
      fontFamily: typography.header.fontFamily,
      lineHeight: '3.4em',
      textTransform: 'uppercase'
    },
    lv2: {
      fontSize: '0.9rem',
      lineHeight: '3.2em'
    },
    lv3: {
      fontSize: '0.8rem',
      lineHeight: '3em'
    },
    activeColor: colors.primary,
    selectedColor: colors.secondary
  }
};

//HEADER HEIGHTS
const header = {
  height: {
    lg: topBar.height.lg + desktopHeader.height.lg,
    md: topBar.height.md + desktopHeader.height.md,
    sm: topBar.height.md + mobileHeader.height.sm,
    xs: topBar.height.md + mobileHeader.height.xs,
    scroll: topBar.height.scroll + desktopHeader.height.scroll
  },
  scrollBreak: 50
};

//LOGO
const logo = {
  size: 400,
  aspect: '230:60'
};

//CAMPAIGN BAR
const campaignBar = {
  primary: {
    background: colors.backgroundLight,
    color: colors.font
  },
  secondary: {
    background: colors.secondary,
    color: colors.white
  }
};

//FOOTER
const footer = {
  background: '#EEE',
  color: colors.font,
  logoBackground: false,
  jetshopBackground: colors.white,
  jetshopColor: '#AAA',
  imageAspect: '4:3',
  newsletterButton: {
    background: 'transparent',
    color: colors.black,
    border: '1px solid ' + colors.black
  }
};

//START PAGE
const startPage = {
  headers: {
    fontFamily: typography.fontFamily,
    fontWeight: weights.bold,
    textTransform: 'uppercase',
    fontSize: [
      '__',
      [remCalc(28), remCalc(50), remCalc(70), remCalc(95)],
      [remCalc(20), remCalc(31), remCalc(41), remCalc(52)],
      [remCalc(18), remCalc(24), remCalc(28), remCalc(31)],
      [remCalc(15), remCalc(20), remCalc(21), remCalc(21)],
      [remCalc(14), remCalc(16), remCalc(17), remCalc(17)]
    ]
  },
  iconBar: {
    background: colors.primary,
    color: colors.white
  },
  row: {
    background: {
      primary: colors.backgroundLight,
      secondary: colors.backgroundDark
    },
    color: {
      primary: colors.font,
      secondary: colors.white
    },
    noImage: {
      backgroundLight: colors.backgroundLight,
      backgroundDark: colors.backgroundDark
    }
  },
  readMore: {
    color: colors.font,
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight
  },
  cta: {
    fontSize: button.fontSize,
    color: colors.white,
    background: colors.primary,
    letterSpacing: button.letterSpacing,
    border: 'none',
    fontFamily: button.fontFamily,
    fontWeight: button.fontWeight,
    textTransform: 'none',
    borderRadius: '0px',
    hover: {
      color: colors.white,
      background: colors.primaryLight,
      border: 'none'
    },
    secondary: {
      color: colors.white,
      background: colors.secondary,
      border: 'none',
      hover: {
        color: colors.secondary,
        background: 'transparent',
        border: 'none'
      }
    },
    third: {
      color: colors.white,
      background: colors.primaryDark,
      border: 'none',
      hover: {
        color: colors.white,
        background: colors.primaryDark,
        border: 'none'
      }
    },
    fourth: {
      color: colors.white,
      background: colors.primaryDark,
      border: 'none',
      hover: {
        color: colors.white,
        background: colors.primaryDark,
        border: 'none'
      }
    }
  }
};

//CATEGORY PAGE
const categoryPage = {
  subcategories: {
    fontFamily: typography.fontFamily,
    fontWeight: weights.bold
  },
  filter: {
    markerColor: colors.buy,
    hoverColor: colors.buy,
    borderColor: colors.border,
    name: {
      tag: 'h4'
    }
  }
};

//PRODUCT GRID
const productGrid = {
  product: {
    imageAspect: '4:3',
    background: '#FFF',
    padding: ['1rem', '1rem', '1rem'],
    border: 'none',
    discount: true,
    centerAlign: true,
    name: {
      tag: 'h4',
      fontFamily: typography.header.fontFamily,
      fontWeight: typography.header.fontWeight
    }
  }
};

const price = {
  fontFamily: typography.header.fontFamily,
  fontWeight: typography.header.fontWeight,
  normal: {
    color: colors.font,
    fontSize: typography.header.fontSize[3]
  },
  new: {
    color: colors.red,
    fontSize: typography.header.fontSize[3]
  },
  old: {
    color: colors.greys[5],
    fontSize: typography.header.fontSize[4]
  }
};

//PRODUCT PAGE
const productPage = {
  name: {
    fontFamily: productGrid.product.name.fontFamily,
    fontWeight: productGrid.product.name.fontWeight
  },
  price: {
    fontWeight: price.fontWeight,
    normal: {
      fontSize: typography.header.fontSize[2]
    },
    new: {
      fontSize: typography.header.fontSize[2]
    },
    old: {
      fontSize: typography.header.fontSize[3]
    }
  },
  imageAspect: '1:1',
  buyButton: {
    background: colors.buy,
    color: colors.white
  },
  usp: {
    fontWeight: weights.bold
  },
  tabs: {
    barActiveColor: colors.secondary,
    header: {
      tag: 'h3',
      fontFamily: typography.header.fontFamily,
      fontWeight: typography.header.fontWeight
    }
  },
  productList: {
    headerColor: colors.primary,
    subHeaderColor: colors.secondary
  }
};

const favourites = {
  colorActive: colors.secondary
};

//EXPORT COMPLETE THEME
export const camelbakTheme = {
  config,
  font,
  weights,
  typography,
  colors,
  general,
  button,
  topBar,
  desktopHeader,
  mobileHeader,
  header,
  logo,
  campaignBar,
  footer,
  startPage,
  categoryPage,
  productGrid,
  price,
  productPage,
  favourites
};
